export default __webpack_public_path__ + "static/pwa-vs-native-b7fb0e6bc291cde3cd17f172d1f0e939.jpg";